// extracted by mini-css-extract-plugin
export default {"tabletImg":"HF","desktopImg":"IF","mobileImg":"JF","backgroundImage":"KF","content":"LF","rtbLeft":"MF","rtbRight":"NF","imageContainer":"OF","rtbBox":"PF","line":"QF","rtbLeftMobile":"RF","rtbDesktop":"SF"};
    if(module.hot) {
      // 1713912566069
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  